import { SETTINGS_LOADING, SETTINGS_FAILED, SETTINGS_LOADING_SUCCESS, FETCH_CALLBACKS_LIST_LOADING, FETCH_CALLBACKS_LIST_SUCCESS, FETCH_CALLBACKS_LIST_FAILED, CLEAR_CALLBACKS_LIST_STATUS, CLEAR_CALLBACKS_LIST_DETAILS, COUNTRY_SLOT_LOADING, COUNTRY_SLOT_FAILED, COUNTRY_SLOT_SUCCESS, C2C_SETTINGS_FAILED, C2C_SETTINGS_LOADING, C2C_SETTINGS_LOADING_SUCCESS } from '../actions/voiceSettings.action';
import { CallbacksListReducer, VoiceSettingsReducer, ClickToCallSettingsReducer, TimeoutProfilesReducer } from '../models/callbacksList.interface';

const initialState: CallbacksListReducer = {
    callbackListLoading: true,
    callbackListError: false,
    callbackListMessage: "",
    callbackListData: [],
    saveLoading: false,
    total: 0,
}

export const callbacksListReducer = (state: CallbacksListReducer = initialState, action: any): CallbacksListReducer => {
    switch (action.type) {

        case CLEAR_CALLBACKS_LIST_STATUS:
            return {
                ...state,
                callbackListError: false,
                callbackListMessage: ""
            }
        case FETCH_CALLBACKS_LIST_LOADING:
            return {
                ...state,
                callbackListLoading: true,
                callbackListError: false,
                callbackListMessage: ""
            }
        case FETCH_CALLBACKS_LIST_SUCCESS:
            return {
                ...state,
                callbackListLoading: false,
                callbackListData: action.payload.data,
                total: action.payload.total,
            }
        case FETCH_CALLBACKS_LIST_FAILED:
            return {
                ...state,
                callbackListLoading: false,
                callbackListError: true,
                callbackListMessage: action.payload.error.message || ""
            }
        case CLEAR_CALLBACKS_LIST_DETAILS:
            return initialState;
        default:
            return state;
    }
}

const settingsInitialState: VoiceSettingsReducer = {
    loading: false,
    error: false,
    message: "",
    data: {
       callServiceType: '',
       callbacks: {
           onCallStart: '',
           onCallAnswer: '',
           onCallEnd: ''
       },
       countries: [
       ],
       retry: {
           count: 0,
           interval: 0
       },
   },
}

const c2cSettingsInitialState: ClickToCallSettingsReducer = {
    loading: false,
    error: false,
    message: "",
    data: {
       callServiceType: '',
       callbacks: {
           fromCallStart: '',
           toCallStart: '',
           fromCallAnswer: '',
           toCallAnswer: '',
           callEnd: ''
       },
       c2cRetry: '0',
       dialDurationLimit: '0',
       ringTimeLimit: '15',
   },
}

export const voiceSettingsReducer = (state: VoiceSettingsReducer = settingsInitialState, action: any): VoiceSettingsReducer => {
    switch (action.type) {
        case SETTINGS_LOADING:
            return {
                ...state,
                error: false,
                loading: true,
            }
        case SETTINGS_LOADING_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                message: "",
                data: action.payload.respose.data,
            }
        case SETTINGS_FAILED:
            return {
                ...state,
                loading: false,
                error: true,
                message: action.payload.error.message || ""
            }
        default:
            return state;
    }
}

export const clickToCallSettingsReducer = (state: ClickToCallSettingsReducer = c2cSettingsInitialState, action: any): ClickToCallSettingsReducer => {
    switch (action.type) {
        case C2C_SETTINGS_LOADING:
            return {
                ...state,
                error: false,
                loading: true,
            }
        case C2C_SETTINGS_LOADING_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                message: "",
                data: action.payload.respose.data,
            }
        case C2C_SETTINGS_FAILED:
            return {
                ...state,
                loading: false,
                error: true,
                message: action.payload.error.message || ""
            }
        default:
            return state;
    }
}

const profilesInitialState: TimeoutProfilesReducer = {
    loading: true,
    error: false,
    message: "",
    data: {
        timeoutProfile : [],
        totalCount: '0'
    }
}

export const timeoutProfilesReducer = (state: TimeoutProfilesReducer = profilesInitialState, action: any): TimeoutProfilesReducer => {
    switch (action.type) {
        case COUNTRY_SLOT_LOADING:
            return {
                ...state,
                error: false,
                loading: true,
            }
        case COUNTRY_SLOT_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                message: "",
                data: action.payload.response.data,
            }
        case COUNTRY_SLOT_FAILED:
            return {
                ...state,
                loading: false,
                error: true,
                message: action.payload.error.message || ""
            }
        default:
            return state;
    }
}

